import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { store } from "../../App";
import { FaWhatsapp, FaClipboardList, FaAngleDown, FaFileDownload } from "react-icons/fa";
import { ImMobile } from "react-icons/im";
import { FiMapPin } from "react-icons/fi";
import { GiSteeringWheel } from "react-icons/gi";
import "../../css/Header.css";
import { apiUrl } from "../Constants";

const FALLBACK_FORM_MENUS = [
  {
    id: 1,
    menu_name_en: "REQUEST A QUOTE",
    menu_name_ar: "طلب عرض سعر",
    slug: "request-a-quote",
    link: "request-a-quote"
  },
  {
    id: 2,
    menu_name_en: "BOOK A TEST DRIVE",
    menu_name_ar: "احجز تجربة قيادة",
    slug: "book-a-test-drive",
    link: "book-a-test-drive"
  }
];

const resolveFormLink = (item) => {
  if (!item) return "#";
  const raw = item.link || item.slug || "";
  if (raw.startsWith("http://") || raw.startsWith("https://")) return raw;
  if (raw.startsWith("/")) return raw;
  return `/${raw}`;
};

const getFormMenuIcon = (item, size = 14) => {
  if (item?.icon_file && typeof item.icon_file === "string") {
    const trimmed = item.icon_file.trim();
    if (trimmed && trimmed !== "null" && trimmed !== "undefined") {
      const isLocal = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
      const base = isLocal ? "http://localhost/foton-oman-backend/public" : "https://dev10.sbagh.com/public";
      const src = (trimmed.startsWith("http://") || trimmed.startsWith("https://") || trimmed.startsWith("/"))
        ? trimmed
        : `${base}/images/menus/thumb/${trimmed}`;
      return <img src={src} alt="" style={{ width: size, height: size, objectFit: "contain" }} className="cta-icon" />;
    }
  }

  const s = ((item?.slug || "") + " " + (item?.menu_name_en || "")).toLowerCase();
  if (s.includes("quote") || s.includes("price")) {
    return <FaClipboardList className="cta-icon" size={size} />;
  }
  if (s.includes("drive") || s.includes("wheel") || s.includes("test")) {
    return <GiSteeringWheel className="cta-icon" size={size + 2} />;
  }
  if (s.includes("brochure") || s.includes("download") || s.includes("pdf")) {
    return <FaFileDownload className="cta-icon" size={size} />;
  }
  return <FaClipboardList className="cta-icon" size={size} />;
};

const PRODUCT_CARD_IMAGES = {
  "medium-duty-truck": "/Images/Card-img/AUMAN-EST-A-ICON.webp",
  "medium-and-heavy-duty-trucks": "/Images/Card-img/AUMAN-EST-A-ICON.webp",
  "light-duty-trucks": "/Images/Card-img/AUMARK-S-ICON.webp",
  "mini-truck": "/Images/Card-img/MINI-TRUCK-ICON.webp",
  "pickup": "/Images/Card-img/TUNLAND-ICON0.webp",
  "van": "/Images/Card-img/VAN-ICON.webp",
  "mini-bus": "/Images/Card-img/MINI-BUS-ICON.webp",
  "showrooms-service": "/Images/Card-img/AUMARK-S-ICON.webp",
  "showrooms": "/Images/Card-img/AUMARK-S-ICON.webp",
  "service-centers": "/Images/Card-img/AUMARK-S-ICON.webp"
};

const getProductImageSrc = (child) => {
  const slug = (child?.slug || "").toLowerCase();

  // 1. Primary: Use dynamic icon_file key from dev10.sbagh.com/api/getMenus
  if (child?.icon_file && typeof child.icon_file === "string") {
    const trimmedIcon = child.icon_file.trim();
    if (trimmedIcon && trimmedIcon !== "null" && trimmedIcon !== "undefined") {
      if (trimmedIcon.startsWith("http://") || trimmedIcon.startsWith("https://") || trimmedIcon.startsWith("/")) {
        return trimmedIcon;
      }
      return `https://dev10.sbagh.com/public/images/menus/large/${trimmedIcon}`;
    }
  }

  // 2. Secondary: Fallback to child.image if provided and not a vertical strip banner
  const verticalStrips = [
    "1792396995.jpg",
    "1792398507.png",
    "1792397652.jpg",
    "1792397680.jpg",
    "1792397694.jpg",
    "1792397708.jpg",
    "mhdt.jpg",
    "ldt.png",
    "mini_truck.jpg",
    "pickup.jpg",
    "van.jpg",
    "bus.jpg"
  ];
  if (child?.image && typeof child.image === "string") {
    const trimmed = child.image.trim();
    const basename = trimmed.split("/").pop();
    if (!verticalStrips.includes(basename)) {
      if (trimmed.startsWith("http://") || trimmed.startsWith("https://") || trimmed.startsWith("/")) {
        return trimmed;
      }
      return `https://dev10.sbagh.com/public/images/menus/large/${trimmed}`;
    }
  }

  // 3. Fallback: High-resolution card images matching reference screenshot (when icon_file is null)
  return PRODUCT_CARD_IMAGES[slug] || "/Images/Card-img/AUMARK-S-ICON.webp";
};

const getProductFallbackSrc = (child) => {
  const slug = (child?.slug || "").toLowerCase();
  return PRODUCT_CARD_IMAGES[slug] || "/Images/Card-img/AUMARK-S-ICON.webp";
};

const VEHICLE_CATEGORY_SLUGS = [
  "mini-truck",
  "van",
  "mini-bus",
  "pickup",
  "light-duty-trucks",
  "medium-duty-truck",
  "medium-and-heavy-duty-trucks",
  "special-vehicles"
];

const getProductTargetLink = (child) => {
  const target = child?.link || child?.slug || "";
  const slug = (child?.slug || "").toLowerCase();
  const link = (child?.link || "").toLowerCase();

  if (slug === "showrooms-service" || link === "show-rooms" || slug === "showrooms") {
    return "/show-rooms";
  }

  // Categories open /vehicles/:slug — product slug (e.g. wonder) is resolved dynamically there
  if (VEHICLE_CATEGORY_SLUGS.includes(slug)) {
    return `/vehicles/${slug}`;
  }

  if (!target) return "/vehicles";
  if (target.startsWith("http://") || target.startsWith("https://")) return target;
  if (target.startsWith("/vechile-details/")) return target;
  if (target.startsWith("/vehicles/")) return target;
  if (target.startsWith("vehicles/")) return `/${target}`;
  if (target.startsWith("/")) return target;
  return `/vehicles/${target}`;
};

export default function BasicExample() {
  const [lang, setLang] = useContext(store);
  const [menuData, setMenuData] = useState(null);
  const [productsData, setProductsData] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState({});
  const [isSticky, setIsSticky] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formMenus, setFormMenus] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const menusEndpoint = apiUrl ? `${apiUrl}getMenus` : "https://dev10.sbagh.com/api/getMenus";
    const homeEndpoint = apiUrl ? `${apiUrl}getHomePageDataBySlug/home` : "https://dev10.sbagh.com/api/getHomePageDataBySlug/home";

    axios
      .get(menusEndpoint)
      .then((res) => {
        if (res.data && res.data.data) {
          setMenuData(res.data.data);
        }
      })
      .catch((err) => {
        console.warn("Could not load remote menus, using fallback", err);
      });

    axios
      .get(homeEndpoint)
      .then((res) => {
        const products = res.data?.data?.foton_products?.products;
        if (Array.isArray(products) && products.length > 0) {
          setProductsData(products);
        }
      })
      .catch((err) => {
        console.warn("Could not load home products data:", err);
      });

    // Dynamic Form Menus from api/getFormMenus
    const formMenusEndpoint = apiUrl ? `${apiUrl}getFormMenus` : "https://dev10.sbagh.com/api/getFormMenus";
    const formMenusFallback = "http://localhost/foton-oman-backend/api/getFormMenus";

    axios
      .get(formMenusEndpoint)
      .then((res) => {
        const items = res.data?.data?.menus;
        if (Array.isArray(items)) {
          setFormMenus(items);
        }
      })
      .catch(() => {
        axios.get(formMenusFallback)
          .then((fbRes) => {
            const items = fbRes.data?.data?.menus;
            if (Array.isArray(items)) {
              setFormMenus(items);
            }
          })
          .catch((err) => {
            console.warn("Could not load dynamic form menus:", err);
          });
      });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 35);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
    setMobileSubmenuOpen({});
    setActiveDropdown(null);
  }, [location.pathname]);

  const toggleMobileSubmenu = (slug) => {
    setMobileSubmenuOpen((prev) => ({
      ...prev,
      [slug]: !prev[slug]
    }));
  };

  const menus = menuData?.menus || [];

  const productsMenu = menus.find((m) => m.id === 3 || m.slug === "models");

  // Default product models matching reference screenshot when menus offline or empty
  const defaultProductModels = [
    {
      id: 12,
      menu_name_en: "Medium Duty Truck",
      menu_name_ar: "شاحنة متوسطة الحمولة",
      slug: "medium-duty-truck",
      link: "vehicles/medium-duty-truck",
      sort: 1,
      icon_file: null,
      image: null
    },
    {
      id: 13,
      menu_name_en: "Light Duty Trucks",
      menu_name_ar: "شاحنات خفيفة",
      slug: "light-duty-trucks",
      link: "vehicles/light-duty-trucks",
      sort: 2,
      icon_file: null,
      image: null
    },
    {
      id: 14,
      menu_name_en: "Pickup",
      menu_name_ar: "بيك أب",
      slug: "pickup",
      link: "vehicles/pickup",
      sort: 3,
      icon_file: null,
      image: null
    },
    {
      id: 18,
      menu_name_en: "SHOWROOMS & SERVICE",
      menu_name_ar: "صالات العرض والخدمة",
      slug: "showrooms-service",
      link: "show-rooms",
      sort: 4,
      icon_file: null,
      image: null
    }
  ];

  // Assemble full dynamic products from getMenus API
  let rawProducts = [];
  if (menus && menus.length > 0) {
    const children = productsMenu?.children || [];
    const standalone = menus.filter(
      (m) =>
        (m.menu_type === 1 || ["mini-truck", "van", "mini-bus", "pickup", "light-duty-trucks", "medium-duty-truck"].includes(m.slug)) &&
        !children.some((c) => c.id === m.id || c.slug === m.slug)
    );
    const combined = [...children, ...standalone];
    if (combined.length > 0) {
      rawProducts = combined;
    }
  } else if (productsData && productsData.length > 0) {
    rawProducts = [...productsData];
  } else {
    rawProducts = defaultProductModels;
  }

  const sortedProducts = [...rawProducts].sort((a, b) => {
    const sortA = parseInt(a.sort, 10) || 999;
    const sortB = parseInt(b.sort, 10) || 999;
    return sortA - sortB;
  });

  const modelsList = sortedProducts.map((child) => ({
    ...child,
    icon_file: child.icon_file !== undefined ? child.icon_file : null,
    imageSrc: getProductImageSrc(child),
    fallbackSrc: getProductFallbackSrc(child),
    targetLink: getProductTargetLink(child)
  }));

  // 100% dynamic navigation items from API menus
  const dynamicNavItems = (menus || [])
    .filter((m) => {
      // Must be active on front-end
      if (m.status !== 1 || m.front_end_menu_status !== 1) return false;
      // Filter out Form menus (menu_type = 2) which belong to top-bar CTA / forms, not main navbar
      if (m.menu_type === 2) return false;
      // Filter out partner logo (id 17 / Gulf Great Sands LLC) which is displayed separately on the right
      if (m.id === 17 || m.link === "gulf-great-sands-llc" || m.slug === "#") return false;
      // Filter out individual vehicle child items if they appear at top-level
      if (m.parent_id || m.parent) return false;
      // Filter out home if present in menus list (since logo is home link)
      if (m.slug === "home" || m.link === "/" || m.id === 1) return false;
      return true;
    })
    .sort((a, b) => {
      const sortA = parseInt(a.sort, 10) || 999;
      const sortB = parseInt(b.sort, 10) || 999;
      return sortA - sortB;
    })
    .map((m) => {
      const isProducts =
        m.id === 3 ||
        m.slug === "models" ||
        m.link === "vehicles" ||
        m.menu_name_en?.toLowerCase() === "products";

      let path = m.link ? `/${m.link.replace(/^\/+/, "")}` : `/${m.slug}`;
      if (m.link === "/") path = "/";

      // Products menu with mega-dropdown
      if (isProducts) {
        return {
          id: m.id,
          slug: m.slug || "models",
          path: path || "/vehicles",
          label_en: (m.menu_name_en || "PRODUCTS").toUpperCase(),
          label_ar: m.menu_name_ar || "المنتجات",
          menuItem: m,
          children: modelsList,
          isMega: true
        };
      }

      // Standard menu items (About Us, Take care, Contact Us, or any dynamic menu from API)
      return {
        id: m.id,
        slug: m.slug,
        path: path,
        label_en: (m.menu_name_en || "").toUpperCase(),
        label_ar: m.menu_name_ar || m.menu_name_en,
        menuItem: m,
        children: Array.isArray(m.children) ? m.children : [],
        isMega: false
      };
    });

  // Sensible fallback only if API menus are not yet loaded or offline
  const fallbackNavItems = [
    {
      id: 2,
      slug: "about-us",
      path: "/about-us",
      label_en: "ABOUT US",
      label_ar: "معلومات عنا",
      menuItem: null,
      children: [],
      isMega: false
    },
    {
      id: 3,
      slug: "models",
      path: "/vehicles",
      label_en: "PRODUCTS",
      label_ar: "نماذج",
      menuItem: null,
      children: modelsList,
      isMega: true
    },
    {
      id: 4,
      slug: "take-care",
      path: "/services",
      label_en: "TAKE CARE",
      label_ar: "خدمات",
      menuItem: null,
      children: [],
      isMega: false
    },
    {
      id: 18,
      slug: "showrooms-service",
      path: "/show-rooms",
      label_en: "SHOWROOMS & SERVICE",
      label_ar: "صالات العرض ومراكز الخدمة",
      menuItem: null,
      children: [
        { id: 19, menu_name_en: "Showrooms", menu_name_ar: "صالات العرض", slug: "showrooms", link: "show-rooms" },
        { id: 20, menu_name_en: "Service Centers", menu_name_ar: "مراكز الخدمة", slug: "service-centers", link: "service-centers" }
      ],
      isMega: false
    },
    {
      id: 6,
      slug: "contact",
      path: "/contact-us",
      label_en: "CONTACT US",
      label_ar: "اتصل",
      menuItem: null,
      children: [],
      isMega: false
    }
  ];

  const navItems = dynamicNavItems.length > 0 ? dynamicNavItems : fallbackNavItems;

  return (
    <header className={`site-header ${lang ? "rtl" : "ltr"}`}>
      {/* ================= TOP UTILITY BAR ================= */}
      <div className="header-top">
        <div className="container-fluid top-flex">
          <div className="top-left">
            {/* Clean top left space matching screenshot */}
          </div>

          <div className="top-right">
            {/* CTA Items - 100% Dynamic from api/getFormMenus */}
            <ul className="cta-nav">
              {(formMenus || [])
                .filter((item) => {
                  const s = ((item.slug || "") + " " + (item.link || "")).toLowerCase();
                  return !s.includes("brochure");
                })
                .map((item, idx) => {
                  const title = lang
                    ? (item.menu_name_ar || item.menu_name_en)
                    : (item.menu_name_en || item.menu_name_ar);
                  return (
                    <li key={item.id || idx} className="cta">
                      <Link to={resolveFormLink(item)}>
                        <span>{(title || "").toUpperCase()}</span>
                        {getFormMenuIcon(item, 14)}
                      </Link>
                    </li>
                  );
                })}
            </ul>

            {/* Quick Action Icons in Dark Container */}
            <div className="top-social-actions">
              <a
                href="https://wa.me/"
                target="_blank"
                rel="noopener noreferrer"
                className="action-circle-btn"
                aria-label="WhatsApp"
              >
                <FaWhatsapp size={14} />
              </a>

              <Link to="/contact-us" className="action-circle-btn" aria-label="Locations">
                <FiMapPin size={14} />
              </Link>

              <a href="tel:+968" className="action-circle-btn" aria-label="Call Us">
                <ImMobile size={13} />
              </a>
            </div>

            {/* Language Switcher */}
            <button
              className="lang-switcher-btn"
              onClick={() => setLang(!lang)}
              aria-label="Toggle language"
            >
              {lang ? "English" : "عربي"}
            </button>
          </div>
        </div>
      </div>

      {/* ================= MAIN NAVIGATION BAR ================= */}
      <div className={`header-bottom ${isSticky ? "sticky" : ""}`}>
        <div className="container-fluid nav-container">
          {/* FOTON White Brand Logo on Left */}
          <Link to="/" className="brand-logo" aria-label="FOTON Oman Home">
            <img
              src="/Images/logo/toton-logo.png"
              alt="FOTON"
              className="foton-logo-img"
            />
          </Link>

          {/* Mobile Menu Toggle Button */}
          <button
            className={`mobile-menu-toggle ${mobileMenuOpen ? "active" : ""}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle Navigation Menu"
          >
            <span />
            <span />
            <span />
          </button>

          {/* Center Navigation Menus */}
          <nav className={`nav-menu-wrapper ${mobileMenuOpen ? "open" : ""}`}>
            <ul className="nav-menu-list">
              {navItems.map((item) => {
                const hasChildren = item.children && item.children.length > 0;
                const isDropdownActive = activeDropdown === item.slug;
                const isMobileOpen = Boolean(mobileSubmenuOpen[item.slug]);

                const isCurrentRouteActive = (() => {
                  const current = location.pathname.toLowerCase();
                  const target = (item.path || "").toLowerCase();
                  if (target === current) return true;
                  if (target !== "/" && current.startsWith(target)) return true;
                  if (hasChildren && item.children.some(child => {
                    const childPath = (child.link ? `/${child.link.replace(/^\/+/, "")}` : `/${child.slug}`).toLowerCase();
                    return childPath === current || current.startsWith(childPath);
                  })) return true;
                  return false;
                })();

                const label = lang
                  ? (item.menuItem?.menu_name_ar || item.label_ar)
                  : (item.menuItem?.menu_name_en || item.label_en);

                return (
                  <li
                    key={item.slug}
                    className={`nav-item ${hasChildren ? "has-children" : ""} ${
                      item.isMega ? "mega-dropdown-parent" : ""
                    } ${isDropdownActive ? "open" : ""} ${isCurrentRouteActive ? "active" : ""}`}
                    onMouseEnter={() => {
                      if (!mobileMenuOpen && hasChildren) {
                        setActiveDropdown(item.slug);
                      }
                    }}
                    onMouseLeave={() => {
                      if (!mobileMenuOpen) {
                        setActiveDropdown(null);
                      }
                    }}
                  >
                    <Link
                      to={item.path}
                      className={`nav-link-custom ${isCurrentRouteActive ? "active" : ""}`}
                      onClick={(e) => {
                        if (mobileMenuOpen && hasChildren) {
                          e.preventDefault();
                          toggleMobileSubmenu(item.slug);
                        } else {
                          setMobileMenuOpen(false);
                          setActiveDropdown(null);
                        }
                      }}
                    >
                      <span>{label}</span>
                      {hasChildren && (
                        <FaAngleDown
                          className={`dropdown-caret ${
                            isDropdownActive || (mobileMenuOpen && isMobileOpen)
                              ? "open"
                              : ""
                          }`}
                          size={11}
                        />
                      )}
                    </Link>

                    {/* Desktop Mega Dropdown (for Products/Models) */}
                    {item.isMega && hasChildren && isDropdownActive && !mobileMenuOpen && (
                      <div className="mega-dropdown">
                        <ul className="model-grid">
                          {item.children.map((child) => (
                            <li key={child.id || child.slug} className="model-card">
                              <Link
                                to={child.targetLink || `/vehicles/${child.slug}`}
                                onClick={() => setActiveDropdown(null)}
                              >
                                <figure>
                                  <div className="model-img-wrap">
                                    <img
                                      src={child.imageSrc}
                                      alt={child.menu_name_en || child.name}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = child.fallbackSrc || "/Images/Card-img/AUMARK-S-ICON.webp";
                                      }}
                                    />
                                  </div>
                                  <figcaption>
                                    {lang
                                      ? (child.menu_name_ar || child.name_ar || child.menu_name_en)
                                      : (child.menu_name_en || child.name)}
                                  </figcaption>
                                </figure>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* Desktop Standard Dropdown (for About Us and any other menus with children) */}
                    {!item.isMega && hasChildren && isDropdownActive && !mobileMenuOpen && (
                      <div className="nav-dropdown">
                        <ul className="nav-dropdown-list">
                          {item.children.map((child) => {
                            const childPath = child.link
                              ? `/${child.link.replace(/^\/+/, "")}`
                              : `/${child.slug}`;
                            const childName = lang
                              ? (child.menu_name_ar || child.menu_name_en)
                              : child.menu_name_en;
                            return (
                              <li key={child.id || child.slug} className="nav-dropdown-item">
                                <Link
                                  to={childPath}
                                  className="nav-dropdown-link"
                                  onClick={() => setActiveDropdown(null)}
                                >
                                  <span>{childName}</span>
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}

                    {/* Mobile Collapsible Submenu Accordion */}
                    {mobileMenuOpen && hasChildren && isMobileOpen && (
                      <ul className="mobile-submenu">
                        {item.isMega && (
                          <li className="mobile-sub-item">
                            <Link
                              to="/vehicles"
                              onClick={() => {
                                setMobileMenuOpen(false);
                                setActiveDropdown(null);
                              }}
                              style={{ fontWeight: 700, color: "#0066b2" }}
                            >
                              {lang ? "عرض جميع الفئات" : "VIEW ALL CATEGORIES"}
                            </Link>
                          </li>
                        )}
                        {item.children.map((child) => {
                          const childPath = item.isMega
                            ? (child.targetLink || `/vehicles/${child.slug}`)
                            : child.link
                            ? `/${child.link.replace(/^\/+/, "")}`
                            : `/${child.slug}`;
                          const childName = lang
                            ? (child.menu_name_ar || child.name_ar || child.menu_name_en)
                            : (child.menu_name_en || child.name);
                          return (
                            <li key={child.id || child.slug} className="mobile-sub-item">
                              <Link
                                to={childPath}
                                onClick={() => {
                                  setMobileMenuOpen(false);
                                  setActiveDropdown(null);
                                }}
                              >
                                {childName}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </nav>

          {/* Right Gulf Great Sands LLC Dealer Brand */}
          <div className="dealer-partner-brand">
            <div className="partner-divider" />
            <img
              src="/Images/logo/GGS_white.png"
              alt="Gulf Great Sands LLC"
              className="partner-logo-img"
            />
          </div>
        </div>
      </div>
    </header>
  );
}
